import * as React from 'react'
import EditVehicleInfo, { IEditVehicleInfoValues } from './edit-vehicle/EditVehicleInfo'
import * as Yup from 'yup'
import { Formik, FormikProps } from 'formik'
import { IVehicleCreateOptions, IVehicleDepotAddress, IVehicleInfo, IVehicleObj } from '../../types'
import { withNotification } from '../ui/notification-provider'
import serviceVehicles from 'src/services/Vehicles'

const validationSchema = Yup.object().shape({
  id: Yup.string(),
  organizationId: Yup.string().required('Is required'),
  licensePlate: Yup.string().required('Is required'),
  makeId: Yup.string().required('Is required'),
  modelId: Yup.string().required('Is required'),
  typeId: Yup.string().required('Is required'),
  year: Yup.number()
    .required('Is required')
    .max(new Date().getFullYear(), "Can't be more than current year")
    .min(1900, "Can't be less than 1900"),
  colorId: Yup.string().required('Is required'),
  defaultAddress: Yup.string().required('Is required')
})

const initialAddress: IVehicleDepotAddress = {
  id: '',
  street: '',
  city: '',
  state: '',
  zip: '',
  country: ''
}

/*TODO figure out why these props cause weird, unfixable errors
interface IEditVehicleFormProps {
  id?: string
  isLoading: boolean
  getVehicleCreateOptions: () => void
  setVehicleSavedStateToInitial: () => void
  createOrUpdateOne: (data: IVehicleInfo) => void
  getSingleVehicle?: (id: string) => void
  createEditVehicle: ICreateEditVehicleData
  savedVehicleId?: string
  vehicleCreateOptions: IVehicleCreateOptions
  vehicle?: IVehicleObj
  nextStep: string
  isDisabledToSetOwnerProvider: boolean
}
*/

const EditVehicleInfoContainer = (
  vehicleCreateOptions: IVehicleCreateOptions,
  isLoading: boolean,
  currentVehicle: IVehicleObj
) => (formikProps: FormikProps<IEditVehicleInfoValues>) => (
  <EditVehicleInfo
    {...formikProps}
    isLoading={isLoading}
    vehicleCreateOptions={vehicleCreateOptions}
    currentVehicle={currentVehicle}
  />
)

/*
  TODO figure out why props interface does not work. Error is impossible to understand

  /Users/casen/work/goin-web/src/containers/vehicles/CreateVehicleFormik.ts
  (35,3): Argument of type 'typeof VehicleForm' is not assignable to parameter of type 'ComponentType<Matching<{ isRequesting: boolean; isRequestingError: string; vehicleCreateOptions: ...'.
    Type 'typeof VehicleForm' is not assignable to type 'FunctionComponent<Matching<{ isRequesting: boolean; isRequestingError: string; vehicleCreateOptio...'.
      Type 'typeof VehicleForm' provides no match for the signature '(props: Matching<{ isRequesting: boolean; isRequestingError: string; vehicleCreateOptions: IVehicleCreateOptionsState; createEditVehicle: ICreateEditVehicleData; savedVehicleId: string | null; isDisabledToSetOwnerProvider: boolean; nextStep: string; history: History<any>; location: Location<any>; match: match<void>; staticContext?: StaticContext | undefined; } & { createOrUpdateOne: any; getSingleVehicle: any; getVehicleCreateOptions: any; }, IEditVehicleFormProps> & { children?: ReactNode; }, context?: any): ReactElement<any> | null'.
*/
class VehicleForm extends React.Component<any> {
  public state = {
    address: initialAddress
  }

  public componentDidMount() {
    this.props.getVehicleCreateOptions()
    if (this.props.id && this.props.getSingleVehicle) {
      this.props.getSingleVehicle(this.props.id)
      this.fetchAddress()
    }
  }

  public fetchAddress = () => {
    serviceVehicles
      .getVehicleDepotAddress(this.props.id)
      .then(data => {
        if (data) {
          this.setState({ address: data[0] })
        }
      })
      .catch(error => {
        console.error('Error fetching vehicle depot address:', error)
        const { notification } = this.props
        notification.addNotification({
          title: 'Error loading vehicle depot address',
          level: 'error'
        })
      })
  }

  public onSubmit = (values: IVehicleInfo) => {
    this.props.createOrUpdateOne(values).then((error: boolean) => {
      if (!error) {
        const { notification } = this.props

        notification.addNotification({
          title: 'Successfully saved vehicle information!',
          level: 'success'
        })
        if (this.props.match.params.id || this.props.savedVehicleId) {
          this.props.history.push(`/vehicles/view/${this.props.match.params.id || this.props.savedVehicleId}/details`)
        } else {
          this.props.history.push(`/vehicles`)
        }
      } else {
        const { notification } = this.props

        notification.addNotification({
          title: 'There has been an error in saving data. Please try again.',
          level: 'error'
        })
      }
    })
  }

  public componentWillUnmount() {
    this.props.setVehicleSavedStateToInitial()
  }

  public render() {
    const vehicle: IVehicleObj = this.props.vehicle
    const address = this.state.address
    return (
      <div>
        <Formik
          validationSchema={validationSchema}
          enableReinitialize={true}
          initialValues={{
            id: this.props.id,
            organizationId: vehicle && vehicle.organizationId ? vehicle.organizationId : this.props.organizationId,
            fleetId: vehicle ? vehicle.fleetId : '',
            licensePlate: vehicle ? vehicle.licensePlate : '',
            makeId: vehicle && vehicle.make ? vehicle.makeId : '',
            modelId: vehicle && vehicle.model ? vehicle.modelId : '',
            typeId: vehicle && vehicle.type ? vehicle.typeId : '',
            year: vehicle ? vehicle.year.toString() : '',
            colorId: vehicle && vehicle.color ? vehicle.colorId : '',
            isDedicated: vehicle ? vehicle.isDedicated : false,
            defaultAddress: vehicle ? vehicle.defaultAddress : '',
            street: address ? address.street : '',
            city: address ? address.city : '',
            zip: address ? address.zip : '',
            state: address ? address.state : '',
            country: address ? address.country : '',
            addressId: address ? address.id : ''
          }}
          onSubmit={this.onSubmit}
          render={EditVehicleInfoContainer(this.props.vehicleCreateOptions, this.props.isLoading, vehicle)}
        />
      </div>
    )
  }
}

export default withNotification(VehicleForm)



// WEBPACK FOOTER //
// ./src/components/vehicles/VehicleForm.tsx